export function appReducer(state = {}, action) {

  switch (action.type) {

    case 'RECEIVE_PROJECTS_SUCCESS': {
      return Object.assign({}, state, { isFetching: false, projects: action.projects })
    }
    case 'RECEIVE_PROJECTS_ERROR': {
      return Object.assign({}, state, { isFetching: false, error: action.error })
    }
    case 'REQUEST_PROJECTS': {
      return Object.assign({}, state, { isFetching: true, projects: [], error: null })
    }

    case 'RECEIVE_CATEGORIES_SUCCESS': {
      return Object.assign({}, state, { isFetching: false, categories: action.categories })
    }
    case 'RECEIVE_CATEGORIES_ERROR': {
      return Object.assign({}, state, { isFetching: false, error: action.error })
    }
    case 'REQUEST_CATEGORIES': {
      return Object.assign({}, state, { isFetching: true, categories: [], error: null })
    }

    case 'SET_CATEGORY': {
      return Object.assign({}, state, { selectedCategory: action.category })
    }

    case 'RECEIVE_NEWS_SUCCESS': {
      return Object.assign({}, state, { isFetching: false, news: action.news })
    }
    case 'RECEIVE_NEWS_ERROR': {
      return Object.assign({}, state, { isFetching: false, error: action.error })
    }
    case 'REQUEST_NEWS': {
      return Object.assign({}, state, { isFetching: true, news: [], error: null })
    }

    case 'RECEIVE_REVIEWS_SUCCESS': {
      return Object.assign({}, state, { isFetching: false, reviews: action.reviews })
    }
    case 'RECEIVE_REVIEWS_ERROR': {
      return Object.assign({}, state, { isFetching: false, error: action.error })
    }
    case 'REQUEST_REVIEWS': {
      return Object.assign({}, state, { isFetching: true, reviews: [], error: null })
    }

    case 'RECEIVE_EXHIBITIONS_SUCCESS': {
      return Object.assign({}, state, { isFetching: false, exhibitions: action.exhibitions })
    }
    case 'RECEIVE_EXHIBITIONS_ERROR': {
      return Object.assign({}, state, { isFetching: false, error: action.error })
    }
    case 'REQUEST_EXHIBITIONS': {
      return Object.assign({}, state, { isFetching: true, exhibitions: [], error: null })
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/app/reducers.js